import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ParametrizacaoService } from 'src/app/services/ParametrizacaoService/parametrizacao.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-notificacoes-parametrizacao',
  templateUrl: './notificacoes-parametrizacao.component.html',
  styleUrls: ['./notificacoes-parametrizacao.component.scss']
})
export class NotificacoesParametrizacaoComponent implements OnInit, OnDestroy {
  private subscription$ = new Subscription();
  private parametrizacaoService = inject(ParametrizacaoService);

  isLoading: boolean = false;
  private pkMailBlck: number = 0;

  form = this.fb.group({
    TX_MAIL_NTFC_BLCK: this.fb.control<string>('', { nonNullable: true }),
  });

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.carregarParametros();
  }

  carregarParametros(): void {
    this.isLoading = true;
    this.parametrizacaoService.GetParametrizacaoByName('TX_MAIL_NTFC_BLCK').subscribe({
      next: (res) => {
        this.pkMailBlck = res.PK_PRMT;
        this.form.controls.TX_MAIL_NTFC_BLCK.setValue(res.VL_PRMT || '');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  salvar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { TX_MAIL_NTFC_BLCK } = this.form.getRawValue();

    this.isLoading = true;

    this.parametrizacaoService.UpdateParametrizacao({
      Parametrizacao: {
        PK_PRMT: this.pkMailBlck,
        NM_PRMT: 'TX_MAIL_NTFC_BLCK',
        VL_PRMT: TX_MAIL_NTFC_BLCK
      }
    }).subscribe({
      next: () => {
        this.isLoading = false;
        Swal.fire('Sucesso!', 'Configurações salvas com sucesso.', 'success');
      },
      error: () => {
        this.isLoading = false;
        Swal.fire('Erro', 'Ocorreu um erro ao salvar as configurações.', 'error');
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
